import styles from './index.module.scss';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Paths } from 'src/pages/paths';
import { Tab } from './Tab';
import { useLocation } from 'react-router';

export const Tabs: FC = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  return (
    <div className={styles.tabs}>
      <div className={styles.tabsContainer}>
        <Tab
          url={Paths.ADMIN_PAGE_USERS_LIST}
          label={t('AdminPage.users')}
          isActive={pathname === `${Paths.ADMIN_PAGE}${Paths.ADMIN_PAGE_USERS_LIST}`}
        />
        <Tab
          url={Paths.ADMIN_PAGE_COMPANIES_LIST}
          label={t('AdminPage.companies')}
          isActive={pathname === `${Paths.ADMIN_PAGE}${Paths.ADMIN_PAGE_COMPANIES_LIST}`}
        />
      </div>
    </div>
  );
};

export default Tabs;
